// extracted by mini-css-extract-plugin
export default {"notebookSelect":"TemporaryNotebookSelect_notebookSelect__8J3Km","customSelect":"TemporaryNotebookSelect_customSelect__dujD+","vectorIcon":"TemporaryNotebookSelect_vectorIcon__aJBmK"};